import { nullable } from "@auditcloud/shared/lib/types/common";
import { unlistenerFunction } from "@/utils/firestore";
import { MeasureWorkflow } from "@auditcloud/shared/lib/workflow/modules/Measure";

export class MeasureWorkflowsState {
  Workflows: { [workflowId: string]: MeasureWorkflow } = {};
  Unlistener: nullable<unlistenerFunction> = null;
  loadedNewQuery: boolean = true;
}
